import { render, staticRenderFns } from "./_entity_id.vue?vue&type=template&id=4ea2bb9a&"
import script from "./_entity_id.vue?vue&type=script&lang=js&"
export * from "./_entity_id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Section: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Section/index.vue').default})
